import type { HalfDoughnutSummaryItem } from "components/widgets/HalfDoughnutSummaryWidget"

export const CHART_COLORS = {
  online: "#22C55E",
  offline: "#E2E8F0",
} as const

export const CHART_COLORS_SPLIT = {
  onlineV1: "#86EFAC",
  offlineV1: "#94A3B8",
  onlineV2: "#14B8A6",
  offlineV2: "#64748B",
} as const

interface InstalledDeviceCounts {
  onlineV1: number
  offlineV1: number
  onlineV2: number
  offlineV2: number
}

export const buildInstalledDeviceItems = (
  thermv2ordering: boolean,
  counts: InstalledDeviceCounts,
): HalfDoughnutSummaryItem[] =>
  thermv2ordering
    ? [
        { label: "Online V1", color: CHART_COLORS_SPLIT.onlineV1, value: counts.onlineV1 },
        { label: "Offline V1", color: CHART_COLORS_SPLIT.offlineV1, value: counts.offlineV1 },
        { label: "Online V2", color: CHART_COLORS_SPLIT.onlineV2, value: counts.onlineV2 },
        { label: "Offline V2", color: CHART_COLORS_SPLIT.offlineV2, value: counts.offlineV2 },
      ]
    : [
        { label: "Online", color: CHART_COLORS.online, value: counts.onlineV1 + counts.onlineV2 },
        { label: "Offline", color: CHART_COLORS.offline, value: counts.offlineV1 + counts.offlineV2 },
      ]
